import { render } from "./MovieListView.vue?vue&type=template&id=5001326d"
import script from "./MovieListView.vue?vue&type=script&lang=js"
export * from "./MovieListView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__